export const CELL = {
    SIZE: 40,
    MARGIN: 2,
};

export enum ITEM_TYPE {
    CELL = "CELL",
}
